import { createReducer, on } from '@ngrx/store';

import { AuthUserState, initialAuthState } from './auth.state';
import {
  DeleteCookiesRedirect,
  DeleteCookiesSuccessLoading,
  errorClear,
  forgotPassword,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  InitAuthSet,
  registerFailed,
  registerLoading,
  registerSuccess,
  requestSuccess,
} from './auth.actions';

export const loginReducer = createReducer(
  initialAuthState,
  on(InitAuthSet, (state, { entity }): AuthUserState => {
    return {
      ...state,
      error: false,
      loading: false,
      entity: entity,
    };
  }),
  on(DeleteCookiesRedirect, (state, { admin }): AuthUserState => {
    return {
      success: false,
      error: false,
      loading: false,
      entity: null,
      redirect: admin ? 'admin' : true,
    };
  }),
  on(DeleteCookiesSuccessLoading, (state): AuthUserState => {
    return {
      success: false,
      error: false,
      loading: false,
      entity: null,
      redirect: false,
    };
  }),
  on(forgotPassword, (state): AuthUserState => {
    return { ...state, loading: true };
  }),
  on(registerLoading, (state): AuthUserState => {
    return { ...state, loading: true };
  }),
  on(forgotPasswordSuccess, (state): AuthUserState => {
    return { ...state, loading: false, success: true };
  }),
  on(forgotPasswordFailure, (state, { response }): AuthUserState => {
    return { ...state, loading: false, success: false, error: response };
  }),
  on(errorClear, (state): AuthUserState => {
    return { ...state, loading: false, success: false, error: false };
  }),
  on(registerFailed, (state, { response }): AuthUserState => {
    return { ...state, loading: false, success: false, error: response };
  }),
  on(registerSuccess, (state, { response }): AuthUserState => {
    return {
      ...state,
      success: true,
      error: response,
      loading: false,
      entity: null,
    };
  }),
  on(requestSuccess, (state, { response }): AuthUserState => {
    return {
      ...state,
      success: true,
      error: response,
      loading: true,
      entity: null,
    };
  })
);
